export default class Golfer {
	constructor(name) {
		this.name = name;
		this.scores = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	}
	get frontScore(){
		return this.scores.filter((el,index) => index < 9).reduce((a,b) => a+b)
	}
	get backScore(){
		return this.scores.filter((el,index) => index>=9 && index<18).reduce((a,b) => a+b)
	}
	get totalScore(){
		return this.scores.reduce((a, c) => a + c)
	}
	get numHolesPlayed(){
		return this.scores.filter(val => val > 0).length
	}
	get currentHoleNumber() {
		return this.scores.indexOf(0)
	}
	getRelativeHoleScore(holeNumber,parArray){
		return  this.scores[holeNumber-1] - parArray[holeNumber-1]
	}
	getRelativeTotalScore(parArray){
		let totalScore = 0
		this.scores.forEach((score,index) => {
			if(score){
				totalScore += (score - parArray[index])
			}
		})
		return totalScore
	}getFormattedScore(parArray){
		let relativeScore = this.getRelativeTotalScore(parArray);
		if (this.numHolesPlayed == parArray.length){
			return this.totalScore
		} else if (relativeScore == 0){
			return 'E'
		}else if (relativeScore > 0){
			return `+${relativeScore}`
		}else {
			return relativeScore
		}
	}
	getFormattedNumHolesPlayed(){
		if (this.numHolesPlayed == 18){
			return 'F'
		}else{
			return this.numHolesPlayed
		}
	}
}
